var render, staticRenderFns
import script from "./GenericCarousel.vue?vue&type=script&lang=js"
export * from "./GenericCarousel.vue?vue&type=script&lang=js"
import style0 from "./GenericCarousel.vue?vue&type=style&index=0&id=4677b9ef&prod&scoped=true&lang=scss"
import style1 from "./GenericCarousel.vue?vue&type=style&index=1&id=4677b9ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4677b9ef",
  null
  
)

export default component.exports